// SCREEN MANAGEMENT
export const RESIZE_WINDOW = "RESIZE_WINDOW";
